export default __webpack_public_path__ + "static/media/AFM_rond_risicoscore5.a5767659.jpg";